import { Link } from 'react-router-dom';
import type { ContentType } from '@/mocks/movies';

interface CategoryEntryProps {
  counts: Record<ContentType, number>;
}

const entries: {
  type: ContentType;
  title: string;
  desc: string;
  icon: string;
  accent: string;
}[] = [
  {
    type: 'movie',
    title: '电影',
    desc: '各国佳片、口碑佳作与院线新片在线看',
    icon: 'ri-film-line',
    accent: 'bg-primary-700 text-accent-400',
  },
  {
    type: 'tv',
    title: '电视剧',
    desc: '国产剧、日韩剧热播连载持续追更',
    icon: 'ri-live-line',
    accent: 'bg-accent-500 text-white',
  },
  {
    type: 'variety',
    title: '综艺',
    desc: '美食、旅行、音乐与真人秀轻松下饭',
    icon: 'ri-mic-line',
    accent: 'bg-secondary-600 text-white',
  },
];

export default function CategoryEntry({ counts }: CategoryEntryProps) {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className="group flex items-center gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/80 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg ${entry.accent}`}>
              <i className={`${entry.icon} text-2xl md:text-3xl`}></i>
            </span>
            <span className="flex-1 min-w-0">
              <span className="flex items-center gap-2">
                <span className="font-heading font-bold text-lg text-foreground-900">{entry.title}</span>
                <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-800 text-[11px]">
                  {counts[entry.type]} 部
                </span>
              </span>
              <span className="block text-sm text-foreground-600 mt-1 leading-relaxed">{entry.desc}</span>
            </span>
            <i className="ri-arrow-right-line text-xl text-foreground-400 group-hover:text-accent-500 transition-colors"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}